import { api, ApiRes } from './client'
import { ProfileTypes } from '../../typings'

export interface ApiCryptoWalletRequest {
    profile_type: ProfileTypes
    success_url: string
    error_url: string
    natural_profile_id?: string // uuid
    legal_profile_id?: string // uuid
}

export interface ApiCryptoWalletResponse {
    created: string
    redirect_url: string
}

export const postCryptoWallet = (requestBody: ApiCryptoWalletRequest): ApiRes<ApiCryptoWalletResponse> =>
    api.post('crypto-wallets', requestBody)
